import axios from 'axios'
import Vue from 'vue'
import {storage} from '../utils/map'
import store from '../store/store'
import router from "@/router";
const JWT_KEY = 'fptai_messenger_user_jwt';

const $http = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_MESSENGER
})
$http.interceptors.request.use(
    config => {
        if (!config.headers) config.headers = {};
        if (storage.has(JWT_KEY)) {
            let userInfo   = storage.getItem(JWT_KEY);
            config.headers.Authorization = `Bearer ${userInfo.user_token}`
        }
        try {
            let referer = String(window.location.href);
            for (let [key, value] of Object.entries(router.currentRoute.params)) {
                referer = referer.replace(String(value), `{${key}}`)
            }
            config.headers["x-fptai-referrer"] = referer
        } catch (e) {
            console.error(e)
        }
        return config
    },
    err => Promise.reject(err)
);
$http.interceptors.response.use(null, error => {
    return new Promise(function (resolve, reject) {
        const response = error.response
        if (response && response.status === 401) {
            store.dispatch('auth/signOut', null, {root: true})
        }
        else {
            reject(error)
        }
    });
});
Vue.prototype.$http = $http;
export default $http
